import React, { useEffect, useRef, useState } from 'react'
import {
    Box,
    Card,
    CardHeader,
    Container,
    Divider,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    Button,
    MenuItem,
    TextField,
} from '@mui/material'
import { Formik } from 'formik'
import * as Yup from "yup";
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';
import SupplierDetailsReport from '../Components/SupplierDetailReportFile'
import xlsx from 'json-as-xlsx';
import StockDetailReportFile from './StockDetailReportFile';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function StockReport() {
    const [pageTitle, setPageTitle] = useState('Stock Details Report');
    const [stockData, setStockData] = useState({
        branchID: 0,
        itemID: 0,
        fromDate: new Date().toISOString().substring(0, 10),
        toDate: new Date().toISOString().substring(0, 10)
    })
    const [itemDetailList, setItemDetailList] = useState([]);
    const [stockDetailList, setStockDetailList] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);


    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - stockDetailList.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    useEffect(() => {
        if (stockData.branchID > 0) {
            GetAllActiveBatchdetail();
        }

        if (stockData.branchID == 0) {
            setStockData({
                ...stockData,
                itemID: 0
            })
            setItemDetailList([]);
        }
    }, [stockData.branchID])


    function GetAllActiveBatchdetail() {
        axios.get(`https://serverfourpaws.ccsoftwares.com/Item/getAllActiveStockDetails/${stockData.branchID}`).then((res) => {
            setItemDetailList(res.data);
        })
    }

    async function createFile() {
        var file = await createDataFromExcel(stockDetailList);
        var settings = {
            sheetName: 'Stock Detail Report',
            fileName: 'Stock Detail Report',
            writeOptions: {}
        }
        let tempcsvHeaders = csvHeaders;
        tempcsvHeaders.push({ label: 'Item Name', value: 'ItemName' })
        tempcsvHeaders.push({ label: 'Category Name', value: 'CategoryName' })
        tempcsvHeaders.push({ label: 'StockInDate', value: 'StockInDate' })
        tempcsvHeaders.push({ label: 'Last Stock Out Date', value: 'lastStockOutDate' })
        tempcsvHeaders.push({ label: 'Stock Expire Date', value: 'StockExpireDate' })
        tempcsvHeaders.push({ label: 'Stock', value: 'Stock' })

        let dataA = [
            {
                sheet: 'Stock Detail Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataFromExcel(dataArray) {
        //console.log("dataArray:> ", dataArray)
        var result = [];
        if (dataArray != null) {
            dataArray.forEach(x => {
                result.push({
                    ItemName: x.itemName,
                    CategoryName: x.CategoryName,
                    StockInDate: x.stockInDate,
                    lastStockOutDate: x.lastStockOutDate,
                    StockExpireDate: x.stockExpireDate,
                    Stock: x.stock
                });
            }
            );
        }
        return result;
    }

    function HandelSearch() {
        const StockModel = {
            branchID: stockData.branchID,
            itemID: stockData.itemID,
            fromDate: stockData.fromDate,
            toDate: stockData.toDate
        }

        axios.post('https://serverfourpaws.ccsoftwares.com/Item/SearchStockDetails', StockModel).then((res) => {
            if (res.data.length > 0) {
                setStockDetailList(res.data);
            } else {
                setStockDetailList([]);
                toast.error("No records to display!");
            }
        })

    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        setStockData({
            ...stockData,
            [e.target.name]: value
        })
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={12} xs={12}>
                    {titleName}
                </Grid>

            </Grid>
        )
    }

    function ClearData() {
        setStockDetailList([]);
        setStockData({
            ...stockData,
            branchID: 0,
            itemID: 0,
            fromDate: new Date().toISOString().substring(0, 10),
            toDate: new Date().toISOString().substring(0, 10)
        })
    }

    return (
        <>
            <Container maxWidth={false} >
                <Formik
                    initialValues={{
                        branchID: stockData.branchID,
                        itemID: stockData.batitemIDchID,
                        fromDate: stockData.fromDate,
                        toDate: stockData.toDate,
                    }}
                    validationSchema={
                        Yup.object().shape({
                        })
                    }

                    onSubmit={() => HandelSearch()}
                    enableReinitialize
                >
                    {({
                        errors,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <Box mt={0}>
                                <Card sx={{ padding: '15px' }}>
                                    <CardHeader
                                        title={cardTitle(pageTitle)}
                                    />
                                    <Divider />
                                    <br />
                                    <Grid container spacing={2}>
                                        <Grid item md={3} sx={12}>
                                            <TextField
                                                select
                                                fullWidth
                                                onBlur={handleBlur}
                                                label="Branch Name *"
                                                name='branchID'
                                                value={stockData.branchID}
                                                id='branchID'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                            >
                                                <MenuItem key={0} value={0}>All Branch</MenuItem>
                                                <MenuItem key={1} value={1}>Main Store</MenuItem>
                                                <MenuItem key={4} value={4}>Rathnapura</MenuItem>
                                                <MenuItem key={2} value={2}>Kalawana</MenuItem>
                                                <MenuItem key={3} value={3}>Palmadulla</MenuItem>
                                            </TextField>
                                        </Grid>
                                        <Grid item md={3} sx={12}>
                                            <TextField
                                                select
                                                fullWidth
                                                onBlur={handleBlur}
                                                label="Item Name *"
                                                name='itemID'
                                                value={stockData.itemID}
                                                id='itemID'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                            >
                                                <MenuItem key={0} value={0}>All Items</MenuItem>
                                                {itemDetailList.map((row) => (
                                                    <MenuItem key={row.itemId} value={row.itemId}>{row.itemName}</MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <TextField
                                                fullWidth
                                                label='Expire From Date *'
                                                name="fromDate"
                                                type='date'
                                                onChange={(e) => handleChange(e)}
                                                value={stockData.fromDate}
                                                variant="outlined"
                                                id="fromDate"
                                                size='small'
                                                onKeyPress={(e) => {
                                                    if (e.key >= '0' && e.key <= '9') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <TextField
                                                fullWidth
                                                label='Expire To Date *'
                                                name="toDate"
                                                type='date'
                                                onChange={(e) => handleChange(e)}
                                                value={stockData.toDate}
                                                variant="outlined"
                                                id="toDate"
                                                size='small'
                                                onKeyPress={(e) => {
                                                    if (e.key >= '0' && e.key <= '9') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Button
                                                variant="contained"
                                                sx={{ width: '200px' }}
                                                onClick={ClearData}
                                            >
                                                clear
                                            </Button>

                                            &nbsp; &nbsp; &nbsp;
                                            <Button
                                                variant="contained"
                                                type='submit'
                                                sx={{ width: '200px' }}
                                            >
                                                Search
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <br /><br />
                                    <Grid container spacing={2}>
                                        <Grid item md={12} xs={12}>
                                            {stockDetailList.length > 0 ?
                                                <TableContainer>
                                                    <Table sx={{ minWidth: 500 }} size="small" aria-label="a dense table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>#</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Item Name</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Category Name</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Stock In Date</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Last Stock Out Date</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Expire Date</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Stock</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {(rowsPerPage > 0
                                                                ? stockDetailList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                : stockDetailList).map((row, index) => (
                                                                    <TableRow key={row._id}>
                                                                        <TableCell align='left'>{index + 1}</TableCell>
                                                                        <TableCell align='left'>{row.itemName}</TableCell>
                                                                        <TableCell align='left'>{row.CategoryName}</TableCell>
                                                                        <TableCell align='left'>{row.stockInDate}</TableCell>
                                                                        <TableCell align='left'>{row.lastStockOutDate}</TableCell>
                                                                        <TableCell align='left'>{row.stockExpireDate}</TableCell>
                                                                        <TableCell align='left'>{row.stock}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            {emptyRows > 0 && (
                                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                                    <TableCell colSpan={5} />
                                                                </TableRow>
                                                            )}
                                                        </TableBody>
                                                        <TableFooter>
                                                            <TableRow>
                                                                <TablePagination
                                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                    colSpan={8}
                                                                    count={stockDetailList.length}
                                                                    rowsPerPage={rowsPerPage}
                                                                    page={page}
                                                                    slotProps={{
                                                                        select: {
                                                                            inputProps: {
                                                                                'aria-label': 'rows per page',
                                                                            },
                                                                            native: true,
                                                                        },
                                                                    }}
                                                                    onPageChange={handleChangePage}
                                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                                    ActionsComponent={TablePaginationActions}
                                                                />
                                                            </TableRow>
                                                        </TableFooter>
                                                    </Table>
                                                </TableContainer>
                                                : null}
                                            {stockDetailList.length > 0 ?
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        id="btnRecord"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem' }}
                                                        onClick={createFile}
                                                        size="small"
                                                    >
                                                        EXCEL
                                                    </Button>
                                                    <div>&nbsp;</div>
                                                    <ReactToPrint
                                                        documentTitle={'Supplier Details Report'}
                                                        trigger={() => (
                                                            <Button
                                                                color="primary"
                                                                type="button"
                                                                variant="contained"
                                                                size='small'
                                                            >
                                                                PDF
                                                            </Button>
                                                        )}
                                                        content={() => componentRef.current}
                                                    />
                                                    <div hidden={true}>
                                                        <StockDetailReportFile
                                                            ref={componentRef}
                                                            stockDetailList={stockDetailList}
                                                        />
                                                    </div>
                                                </Box>
                                                : null}
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Box>
                        </form>
                    )

                    }
                </Formik>
            </Container>

        </>

    )
}

export default StockReport